<template>
	<div class="meeting-details max-content">
		<div class="introduction">
			<div class="cover">
				<!-- <img :src="meetingInfo.banner" alt=""> -->
				<van-swipe :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item, key, index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
						<img :src="item.image" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
			<div>
				<h3>{{ meetingInfo.name }}</h3>
				<div class="time">
					<p><van-icon name="clock-o" /> {{ meetingInfo.start_at + ' - ' + meetingInfo.end_at }}</p>
					<div class="operation" v-if="showCollect">
						<div class="attention" @click="collectMeeting">{{ collectStaus }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="relation2" v-if="meetingButton.length != 0 && meetingInfo.magnification == '2'">
			<a :style="{ width: button_rows == 4 ? '25%' : '33.33%' }" href="Javascript:void(0)"
				v-for="(item, index) in meetingButton" :key="index" title="picname" @click="skipLink(item)">
				<img :src="item.icon" alt="">
				<span>{{ item.name }}</span>
			</a>

		</div>
		<div class="relation" v-else-if="meetingButton.length != 0">
			<a :style="{ width: button_rows == 4 ? '25%' : '33.33%' }" href="Javascript:void(0)"
				v-for="(item, index) in meetingButton" :key="index" title="picname" @click="skipLink(item)">
				<img :src="item.icon" alt="">
				<span>{{ item.name }}</span>
			</a>

		</div>
		<div class="hr-7"></div>
		<div class="liveDetails">
			<h3 v-if="meeting_dates.length != 0">会议直播</h3>
			<div class="dateList">
				<div class="item" v-for="item in scheduleDate" :key="item">
					<a href="javascript:void(0)" @click="switchDate(item)" :class="item == active ? 'active' : ''">
						{{ item }}
					</a>
				</div>
			</div>
			<!-- <div class="dateMeeting" :class="scheduleList.length%2==0?'both':'odd'" v-if="scheduleList"> -->
			<div class="dateMeeting" :class="date_rows[active] && date_rows[active] == 1 ? 'odd' : 'both'" v-if="scheduleList">
				<van-loading v-if="loading" color="#901d22"></van-loading>
				<div class="item" v-for="(item, index) in scheduleList" :key="index">
					<router-link :to="{ path: '/meeting/live', query: { 'meeting_id': meeting_id, 'id': item.id } }">
						<div class="cover">
							<img :src="item.banner" alt="">
						</div>
					</router-link>
				</div>
			</div>
			<div class="details">
				<div class="item">
					<span>会议地点 : </span>
					<p v-if="meetingInfo.province">{{ meetingInfo.province.name }} {{ meetingInfo.city.name }}
						{{ meetingInfo.address }}</p>
				</div>
				<div class="item" v-if="meetingInfo.organizers">
					<span>主办单位 : </span>
					<div>
						<p v-html="meetingInfo.organizers"></p>
					</div>
				</div>
				<div class="item" v-if="meetingInfo.contractor">
					<span>承办单位 : </span>
					<div>
						<p v-html="meetingInfo.contractor"></p>
					</div>
				</div>
				<div class="item" v-if="meetingInfo.co_sponsors">
					<span>协办单位 : </span>
					<p v-html="meetingInfo.co_sponsors"></p>
				</div>
				<div class="item" v-for="(item, index) in customOrganizations" :key="index">
					<span>{{ item.title }} : </span>
					<p v-html="item.custom_organizers"></p>
				</div>
			</div>
		</div>
		<div class="footerHeight">
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import Footer from "@/components/Footer.vue"
import { MeetingsDetails, MeetingsSchedule, MeetingsPlace, MeetingFollows, MeetingButtons, MeetingsCarousel, meetingCustomOrganize } from '../../config/interface.js'
import { ImagePreview } from 'vant'    //预览图片   使用的函数调用
export default {
	components: {
		Footer
	},
	data() {
		return {
			floatWindow: true,
			giftshow: true,  //礼物显示
			activityObj: {},   //活动对象
			meeting_id: 0,	//会议id
			meetingInfo: {},   //会议信息
			meeting_dates: [],   //日期会议
			liveList: [],     //会议列表
			collectStaus: '收藏',
			meetingButton: [],    //会议按钮
			swiperImg: {},     //轮播图
			showCollect: false,   //是否显示收藏按钮   默认不显示(非微信浏览器不显示)
			button_rows: 4,     //menu一行按钮数量
			loading: false,
			active: 0,
			scheduleDate: [],
			scheduleList: [],
			meetingSchedule: [],
			date_rows: {},
			customOrganizations: []

		}
	},
	beforeRouteEnter(to, from, next) {
		//  修复iOS版微信HTML5 History兼容性问题
		if (to.path !== location.pathname) {

			location.assign(to.fullPath)
		} else {
			next()
		}
	},
	created() {

	},
	mounted() {
		this.meeting_id = this.$route.query.meeting_id;
		if (this.meeting_id == 335) {
			this.$router.replace("/vascularNews/meeting/index?meeting_id=335");
		} else if (this.meeting_id == 522) {
			this.$router.replace("/vascularNews/meeting/index?meeting_id=522");
		} else if (this.meeting_id == 525) {
			this.$router.replace("/vascularNews/meeting/index?meeting_id=525");

		}
		else {
			this.getMeetingDetails(this.meeting_id);
			this.getMeetingButtons(this.meeting_id);
			this.getSchedule();
			this.getMeetingCarousel();
			this.getMeetingOrganization();
			if (common.is_weixin()) {
				this.showCollect = true;
			}
		}
	},
	methods: {
		getSchedule() {
			const url = MeetingsSchedule;
			let params = {
				meeting_id: this.meeting_id,
				from_index: 1

			}
			const method = "POST";
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						var data = res.data;
						this.meetingSchedule = data.sessions;
						this.date_rows = data.date_rows;
						this.scheduleDate = Object.keys(this.meetingSchedule);
						this.switchDate(this.scheduleDate[0]);
					}
				})
		},
		//切换日期
		switchDate(date) {
			this.active = date;
			this.loading = true;
			setTimeout(() => {
				this.scheduleList = this.meetingSchedule[date];
				this.loading = false;
			}, 500)
		},
		//处理日期  09:30样式
		handleDate(date) {
			let time = (date.split(' ')[1]).split(':')
			return time[0] + ':' + time[1];
		},
		//个性化单位
		getMeetingOrganization() {
			const url = meetingCustomOrganize;
			let params = {
				meeting_id: this.meeting_id
			}
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.customOrganizations = data;
					}
				})
		},
		//跳转链接
		skipLink(item) {
			if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
				ImagePreview({
					images: [item.url],
					closeable: true,
					showIndex: false
				});
			} else {
				window.localStorage.removeItem('callback_url');
				window.localStorage.setItem('callback_url', item.url);
				// setTimeout(()=>{
				window.location.href = item.url;

				// },50)
			}

		},
		//会议轮播
		getMeetingCarousel() {
			const url = MeetingsCarousel;
			let params = {
				meeting_id: this.meeting_id
			}
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.swiperImg = data;
					}
				})
		},
		clickSwiperImg(item) {
			window.location.href = item.link;
		},
		//会议详情
		getMeetingDetails(id) {
			this.$store.dispatch('isShowLoading', true);
			const url = MeetingsDetails;
			const method = 'POST';
			let params = {
				meeting_id: id
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						document.title = data.name;
						let currentDate = new Date();
						let currentTime = currentDate.getTime();
						let startTime = new Date(data.start_at.split(' ')[0]).getTime();
						let endTime = new Date(data.end_at.split(' ')[0]).getTime();
						if (currentTime < startTime) {
							data.tipText = "即将开始直播";
						} else if (currentTime >= startTime && currentTime < endTime) {
							data.tipText = "正在直播";
						} else if (currentTime > endTime) {
							data.tipText = "观看录播";
						}
						this.button_rows = data.button_rows;
						data.is_follow == 0 ? this.collectStaus = '收藏' : this.collectStaus = '取消收藏';
						data.start_at = ((data.start_at.split(' ')[0]).split('-')).join('.');
						let end_at_arr = (data.end_at.split(' ')[0]).split('-');
						data.end_at = end_at_arr[1] + '.' + end_at_arr[2];

						if (data.organizers != null) {
							data.organizers = data.organizers.replace(/(\r\n|\n|\r)/gm, "<br/>");
						}
						if (data.contractor != null) {
							data.contractor = data.contractor.replace(/(\r\n|\n|\r)/gm, "<br/>");
						}
						if (data.co_sponsors != null) {
							data.co_sponsors = data.co_sponsors.replace(/(\r\n|\n|\r)/gm, "<br/>");
						}
						this.meetingInfo = data;
						// this.meeting_dates=data.meeting_dates;
						//微信浏览器  请求jsdk
						if (common.is_weixin()) {
							common.wxShare(data.name, data.title, data.shareimg);
						}


					}
					this.$store.dispatch('isShowLoading', false);
				})
		},
		//会议列表
		queryMeetingList() {
			console.log(11)
		},
		//会议收藏和取消收藏(关注)
		collectMeeting() {
			const url = MeetingFollows;
			const method = 'POST';
			let params = {
				meeting_id: this.meeting_id
			};
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						data.attach == 0 ? this.collectStaus = '收藏' : this.collectStaus = '取消收藏';
					}
				})
		},
		//会议按钮
		getMeetingButtons(id) {
			const url = MeetingButtons;
			const method = 'POST';
			let params = {
				meeting_id: id
			};
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						for (let i in data) {
							var obj = {
								url: data[i].url,
								name: data[i].name,
								icon: data[i].icon
							}
							this.meetingButton.push(obj);
						}
					}
				})
		}
	}
}
</script>
<style lang="scss">
.meeting-details {
	position: relative;

	.introduction {
		padding: 14px 12px;
		border-bottom: 1px solid #f1f2f4;

		.cover {
			margin-bottom: 14px;

			img {
				width: 100%;
				border-radius: 5px;
			}
		}

		h3,
		h4 {
			line-height: 30px;
			color: $color-black;
		}

		h3 {
			font-size: 15px;
		}

		h4 {
			font-size: 13px;
			font-weight: 400;
		}

		.time {
			margin-top: 5px;
			@include flex(row);
			justify-content: space-between;
			align-items: center;

			p {
				color: $color-gray;
				font-size: 12px;

			}

			.operation {
				@include flex(row);
				align-items: center;
			}

			i {
				vertical-align: -4px;
				color: $color-black;
				font-size: 16px;
				margin-right: 3px;
			}

			.attention {
				font-size: 11px;
				color: $color-black;
				padding: 3px 11px;
				border: 1px solid #d3d3d3;
				border-radius: 2px;
			}

		}
	}

	.relation {
		padding: 15px 0;
		@include flex(row);
		align-items: center;
		flex-wrap: wrap;

		div {
			text-align: center;
		}

		img {
			height: 40px;
		}

		span {
			color: #242424;
			display: block;
			margin-top: 5px;
			font-size: 15px;
		}

		a {
			width: 25%;
			text-align: center;
			margin-bottom: .4rem;
		}
	}

	.relation2 {
		padding: 15px 0;
		@include flex(row);
		align-items: center;
		flex-wrap: wrap;

		div {
			text-align: center;
		}

		img {
			height: 64px;
		}

		span {
			color: #242424;
			display: block;
			margin-top: 5px;
			font-size: 0.4rem;
			font-weight: bold;
		}

		a {
			width: 25%;
			text-align: center;
			margin-bottom: .4rem;
		}
	}

	.liveDetails {
		padding: 0px 12px 14px;

		h3 {
			font-size: 17px;
			color: $color-black;
			line-height: 30px;
		}

		h4 {
			font-size: 15px;
			color: $color-black;
			line-height: 30px;
		}

		.dateList {
			padding: 15px 0px;
			border-bottom: 1px solid #ddd;
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 25%;
				margin-bottom: 5px;
			}

			a {

				background: #ececec;
				display: block;
				border-radius: 3px;
				font-size: 13px;
				color: #444;
				margin: 0 5px;
				text-align: center;
				padding: 5px 0;
			}

			a.active {
				color: #901d22;
			}
		}

		.dateMeeting {
			position: relative;
		}

		.dateMeeting.odd {
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 100%;
				margin-bottom: 10px;
			}

		}

		.dateMeeting.both {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.item {
				width: 48%;
			}

		}

		.cover {
			position: relative;
			margin: 12px 0;

			img {
				width: 100%;
				border-radius: 5px;
			}

			span {
				color: #fff;
				/*font-weight:700;*/
				font-size: 15px;
				letter-spacing: 1px;
				position: absolute;
				left: 20px;
				top: 50%;
				transform: translate(0, -50%);
			}
		}

		.details {
			.item {
				@include flex(row);
				color: $color-gray;
				font-size: 12px;
				letter-spacing: 1px;
				/*no*/
				letter-spacing: .46px;
				margin-bottom: 15px;

				p,
				span {
					margin-right: 5px;
					line-height: 20px;
					min-width: 65px;
					text-align: justify;
				}

				p {
					flex: 1;
				}
			}
		}

	}

	// 领取礼物
	.receiveGifts {
		@include flex(row);
		align-items: center;
		position: fixed;
		right: 0px;
		bottom: 60px;
		width: 82px;
		height: 44px;
		background: rgba(244, 103, 45, 1);
		box-shadow: 0px 4px 10px 0px rgba(53, 19, 18, 0.27);
		border-radius: 100px 0px 0px 100px;

		img {
			width: 60px;
			position: absolute;
			left: -12px;

		}

		p {
			margin-left: 45px;
			font-size: 11px;
			color: #fff;
			text-align: center;
			text-shadow: 0px 1px 1px rgba(152, 54, 10, 0.46)
		}
	}

	.van-popup {
		border-radius: 11px;
	}

	.van-loading {
		position: absolute;
		left: 50%;
		top: 30%;
		transform: translate(-50%, 0);
		z-index: 100;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/Meeting/details.vue